import './topbar.scss';
// import { Person, Mail } from "@material-ui/icons";
// import '../../../public/assets/Mail.png';
// import '../../../public/assets/Person.png'

export default function Topbar({ menuOpen, setMenuOpen }) {
    return (
        <div className={"topbar " + (menuOpen && "active")}>
            <div className="wrapper">
                <div className="left">
                    <a href="#intro" className='logo'>KHURSHEED</a>
                    <div className='itemContainer'  >


                        <img src='../assets/Person.png' className='phone' style={{ width: "30px", height: "30px", marginRight: "9px" }} />
                        <span className='phone' style={{ marginRight: "7px", paddingRight: "17px" }}>+923417122946</span>

                        <img src='../assets/Mail.png' className='phone' style={{ width: "30px", height: "25px", marginRight: "0px", marginLeft: "17px" }} />
                        <span className='phone' style={{ marginRight: "25rem", marginLeft: "7px", paddingRight: "17px" }}>Khursheed6577@gmail.com</span>


                        <a href='https://github.com/Pro-Programmer38/' target='_blank' >
                            <img src='../assets/github.png' className='icon' style={{ width: "40px", height: "40px", marginTop: "2px", paddingLeft: "0px", marginRight: "4px" }} />
                        </a>

                        <a href='https://www.linkedin.com/in/khursheed-ahmed-8073b0233/' target='_blank' >
                            <img src='../assets/linkedin.png' className='icon' style={{ width: "22px", height: "20px", marginTop: "2px", paddingLeft: "6px", marginRight: "9px" }} />
                        </a>

                        <a href='https://www.instagram.com/the_proprogrammer/' target='_blank' >
                            <img src='../assets/insta.png' className='icon' style={{ width: "22px", marginTop: "7px", paddingLeft: "6px", paddingRight: "3px" }} />
                        </a>



                    </div>
                    <div className='itemContainer'>
                        {/* <Mail className='icon' /> */}
                        {/* <span>Khursheed6577@gmail.com</span> */}
                    </div>
                </div>
                <div className="right">
                    <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                        <span className="line1"></span>
                        <span className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
            </div>
        </div>
    );
}
